export const extractCombineSteps = <T extends object>(operation: {
  parameters: T | { steps: T[] };
}): T[] => ('steps' in operation.parameters ? operation.parameters.steps : [operation.parameters]);
